import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface RefreshState {
  refresh(): void;
}

export const initialState: RefreshState = {
  refresh() {
    console.log('current Refresh is none')
  },
};

export const RefreshReducer = reducerWithInitialState(initialState)
  .case(actions.updateRefresh, (state: RefreshState, payload: RefreshState) => {
    return payload;
  });
